import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchMerchantDeviceReturnStatus } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const deviceReturnStatusSlice = createAsyncThunk('get/deviceReturnStatusSlice', FetchMerchantDeviceReturnStatus);

export const DeviceReturnStatusSlice = createSlice({
	name: 'deviceReturnStatusSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[deviceReturnStatusSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[deviceReturnStatusSlice.rejected.toString()]: setAPIError,
		[deviceReturnStatusSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[DeviceReturnStatusSlice.name]: ReturnType<typeof DeviceReturnStatusSlice.reducer>;
}

export const deviceReturnStatusSelector = (state: IStates): any => {
	return state[DeviceReturnStatusSlice.name] || {};
};

export const useDeviceReturnStatus = (): any => useSelector(deviceReturnStatusSelector);

export const getDeviceReturnStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(deviceReturnStatusSlice({}));
		return;
	};

export const resetDeviceReturnStatus =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(DeviceReturnStatusSlice.actions.RESET());
		return;
	};
